module.exports = __webpack_public_path__ + "static/img/rain.510226f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rain.jpeg
// module id = mA1V
// module chunks = 1